import { useContext, useState } from 'react';
import { Alert, Button, Modal, Select, message } from 'antd';
import ProfileContext from 'services/profileContext';
import DomainContext from 'services/domainContext';
import { allocatePoints } from 'services/api/domains';
import { handleDomainAccessError } from 'utils/domainAccessErrors';
import { usePostHogFeatureFlag } from 'hooks/usePostHogFeatureFlag';

const ModalPointsToAllocate = () => {
  const proPlansEnabled = usePostHogFeatureFlag('pro-plan');
  const { profile, updateProfile } = useContext(ProfileContext);
  const { domains, updateDomains } = useContext(DomainContext);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOk = async () => {
    if (!selectedDomain) {
      message.error('Please select a domain');
      return;
    }
    setIsLoading(true);
    const domainName = domains.find(
      (domain) => domain._id === selectedDomain
    )?.name;
    allocatePoints({
      amount: profile.pointsToAllocate,
      name: domainName,
    })
      .then(() => {
        updateDomains();
        updateProfile();
        message.success('Points allocated successfully');
        setIsModalOpen(false);
        setSelectedDomain(null);
      })
      .catch((error) => {
        if (handleDomainAccessError(error, { proPlansEnabled })) {
          return;
        }
        message.error(
          error.response?.data?.error ||
            'Failed to allocate points, please try again or contact support'
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (!profile?.pointsToAllocate) {
    return null;
  }
  return (
    <>
      <Alert
        showIcon
        message={`You have ${profile.pointsToAllocate} points to allocate to a domain!`}
        type="warning"
        style={{ marginBottom: '12px' }}
        action={
          <Button
            size="small"
            type="primary"
            onClick={() => setIsModalOpen(true)}
          >
            Allocate Points
          </Button>
        }
      />
      <Modal
        title="Allocate Points"
        open={isModalOpen}
        onOk={handleOk}
        okText={`Allocate ${profile.pointsToAllocate} points`}
        onCancel={() => {
          setIsModalOpen(false);
          setSelectedDomain(null);
        }}
        confirmLoading={isLoading}
      >
        <p>You have {profile.pointsToAllocate} points to allocate!</p>
        <p>Choose a domain to allocate your points to:</p>
        <Select
          style={{ width: '100%' }}
          placeholder="Select a domain"
          onChange={(value) => setSelectedDomain(value)}
          value={selectedDomain}
        >
          {domains?.map((domain) => (
            <Select.Option key={domain._id} value={domain._id}>
              {domain.name}
            </Select.Option>
          ))}
        </Select>
      </Modal>
    </>
  );
};

export default ModalPointsToAllocate;
